<template>
  <div id="app"  style="height: 100%;width: 100%">
    <router-view />
  </div>
</template>
